uvex-location-list {
  display: block;

  .gm-style-iw-d {
    padding: 0 1rem;
    border: 2px solid #c9c7c7;
  }
}
